import { Component } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalService } from '@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-cardy-ai',
  templateUrl: './cardy-ai.component.html',
  styleUrls: ['./cardy-ai.component.scss']
})
export class CardyAiComponent {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  cardyaiEvent$: BehaviorSubject<any>;
  constructor(
    private httpService: HttpService,
    private authService:AuthService,
    private sessionStorage: LocalService
  ) {
    this.cardyaiEvent$ = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        cardyaiEndpoint: environment.cardyaiChatEndpoint
      };
      this.cardyaiEvent$.next({
        RBACORG: this.RBACORG,
        HTTPSERVICE: this.httpService,
      });
    });
  }

  ngOnInit(): void {
    console.log();
  }

  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}

